/**
 * Возвращает инициалы из полного имени (первые буквы фамилии и имени).
 *
 * @example
 * getInitials('Иванов Иван Иванович') // 'ИИ'
 * getInitials('Петров') // 'П'
 * getInitials('') // ''
 */
export const getInitials = (fullName?: string): string => {
  if (!fullName) return '';

  const parts = fullName.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const second = parts[1]?.[0] ?? '';

  return first + second;
};
